import { QuickEntry } from "../../Definitions";

export interface AutoReport {
  reportId?: number;
  name?: string;
  filterParameter?: QuickEntry[];
};

export const TestData: AutoReport[] = [
  {
    reportId: 1,
    name: "Animals with Empty feed curve",
    filterParameter: [{ key: "feedCurveId", value: [{id: 22, label: "Empty feed curve"}] }],
  },
  {
    reportId: 2,
    name: "Animals in Farrowing",
    filterParameter: [{ key: "milestone_id", value: [{id: 2, label: "Farrowing"}] }],
  },
];
